import React from 'react';
import { ArrowRightIcon, CheckIcon, BookOpenIcon, MicIcon, CalendarIcon, LayersIcon } from 'lucide-react';
import { PageTransition } from '../../components/layout/PageTransition';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { DecorativeShape } from '../../components/DecorativeShape';
import { Animate } from '../../components/ui/Animate';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
export function LeadingInComplexity() {
  const {
    t
  } = useLanguage();
  const signs = t('leadingInComplexity.signs') as string[];
  const whatWeDoItems = t('leadingInComplexity.whatWeDoItems') as string[];
  return <PageTransition data-id="element-1668" data-mp="y0fu56zq4gna">
      <div className="pt-12 pb-24" data-id="element-1669" data-mp="xz4v1kh83x2i">
        {/* Hero */}
        <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1670" data-mp="1uk5f95ggobre">
          <DecorativeShape type="blob" color="bg-blue-100/60" className="top-0 right-0 w-[500px] h-[500px] translate-x-1/4 -translate-y-1/4 -z-10" data-id="element-1671" data-mp="1prvh525705e1" />
          <Animate className="max-w-3xl" data-id="element-1672" data-mp="cttv0ft1qqbm">
            <span className="inline-block px-4 py-2 bg-blue-50 text-blue-700 font-medium rounded-full text-sm mb-6" data-id="element-1673" data-mp="csr6ufn3z1ze">
              {t('leadingInComplexity.badge')}
            </span>
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-1674" data-mp="3269swn325il">
              {t('leadingInComplexity.title')}
              <br data-id="element-1675" data-mp="3l7srrjnuefq6" />
              <span className="text-blue-600" data-id="element-1676" data-mp="3q86z0zhmdln5">{t('leadingInComplexity.titleHighlight')}</span>
            </h1>
            <p className="text-xl text-gray-600 mb-6 leading-relaxed" data-id="element-1677" data-mp="3bb64ypbyheli">
              {t('leadingInComplexity.intro1')}
            </p>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-1678" data-mp="3gb28yoknl612">
              {t('leadingInComplexity.intro2')}
            </p>
            <Link to="/contact" data-id="element-1679" data-mp="19hgmdzb9jii7">
              <Button size="lg" rightIcon={<ArrowRightIcon size={20} data-id="element-1681" data-mp="1ehl5lx3k2rc4" />} data-id="element-1680" data-mp="1eie6ihfu2mmc">
                {t('leadingInComplexity.heroCta')}
              </Button>
            </Link>
          </Animate>
        </section>

        {/* Signs */}
        <section className="bg-cream py-20 mb-20" data-id="element-1682" data-mp="181cjks49geiu">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1683" data-mp="184qni4skovse">
            <Animate className="mb-12" data-id="element-1684" data-mp="133t5ptbh63rf">
              <h2 className="text-3xl font-bold text-charcoal" data-id="element-1685" data-mp="z1plaf6tvou0">
                {t('leadingInComplexity.signsTitle')}
              </h2>
            </Animate>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1686" data-mp="1vrgqb8cqwue2">
              {signs.map((sign, i) => <Animate key={i} delay={i * 0.05} data-id="element-1687" data-mp="1qtng848bng8i" data-mpi={i}>
                  <div className="flex items-start gap-3 bg-white rounded-2xl p-5 shadow-sm" data-id="element-1688" data-mp="1m1dmed435w0y">
                    <div className="mt-0.5 p-1 rounded-full bg-blue-50 text-blue-600 flex-shrink-0" data-id="element-1689" data-mp="1i13dosowsrie">
                      <CheckIcon size={14} strokeWidth={3} data-id="element-1690" data-mp="2eipz1feozf4l" />
                    </div>
                    <span className="text-gray-700" data-id="element-1691" data-mp="29rzqxuevsy67">{sign}</span>
                  </div>
                </Animate>)}
            </div>
          </div>
        </section>

        {/* What we work on */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1692" data-mp="17ert217gf4w">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-1693" data-mp="59rxxrjv6f27">
            <Animate data-id="element-1694" data-mp="5bw7oq4g28ae">
              <h2 className="text-3xl font-bold text-charcoal mb-6" data-id="element-1695" data-mp="a8mqhl7mvhzi">
                {t('leadingInComplexity.whatWeDoTitle')}
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-1696" data-mp="f76a3eyr8hop">
                {t('leadingInComplexity.whatWeDoP1')}
              </p>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1697" data-mp="oxr74xys5e5i">
                {t('leadingInComplexity.whatWeDoP2')}
              </p>
            </Animate>
            <Animate delay={0.1} data-id="element-1698" data-mp="syuqhug1dsbh">
              <div className="space-y-3" data-id="element-1699" data-mp="xyh25zg7v0i6">
                {whatWeDoItems.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-1700" data-mp="xwmi0ncrrcf5" data-mpi={i}>
                    <div className="mt-1 p-1 rounded-full bg-blue-50 text-blue-600 flex-shrink-0" data-id="element-1701" data-mp="12y1y0103asqo">
                      <CheckIcon size={14} strokeWidth={3} data-id="element-1702" data-mp="p98m022v3w2h" />
                    </div>
                    <span className="text-gray-700" data-id="element-1703" data-mp="kayuc1gcjdlm">{item}</span>
                  </div>)}
              </div>
            </Animate>
          </div>
        </section>

        {/* Ways to work together */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1704" data-mp="u2bk8nil3tp0">
          <Animate className="mb-12" data-id="element-1705" data-mp="6cqot558v3yu">
            <h2 className="text-3xl font-bold text-charcoal" data-id="element-1706" data-mp="6dsd4bb9tmyi">
              {t('leadingInComplexity.waysTitle')}
            </h2>
            <p className="text-gray-500 mt-2" data-id="element-1707" data-mp="gaobho7ggspc">{t('leadingInComplexity.waysSubtitle')}</p>
          </Animate>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1708" data-mp="basjknc18rq5">
            {[{
            icon: <BookOpenIcon size={24} className="text-blue-600" data-id="element-1709" data-mp="1roimhqrf19y7" />,
            typeBg: 'bg-blue-50 text-blue-700',
            typeKey: 'courseLabel',
            titleKey: 'course1Title',
            descKey: 'course1Desc',
            path: '/services/courses'
          }, {
            icon: <LayersIcon size={24} className="text-teal" data-id="element-1710" data-mp="1zae3tkqq5q60" />,
            typeBg: 'bg-teal/10 text-teal',
            typeKey: 'workshopLabel',
            titleKey: 'workshop1Title',
            descKey: 'workshop1Desc',
            path: '/services/workshops'
          }, {
            icon: <MicIcon size={24} className="text-yellow-600" data-id="element-1711" data-mp="2d2arncld1dwl" />,
            typeBg: 'bg-yellow-100 text-yellow-700',
            typeKey: 'talkLabel',
            titleKey: 'talk1Title',
            descKey: 'talk1Desc',
            path: '/services/talks'
          }].map((item, i) => <Animate key={i} delay={i * 0.1} data-id="element-1712" data-mp="2vzby71ukbm2n" data-mpi={i}>
                <Card hoverEffect className="h-full p-6 flex flex-col" data-id="element-1713" data-mp="2vxiplh0e2rs0">
                  <div className="flex items-center gap-3 mb-4" data-id="element-1714" data-mp="30qu1vxnz00rb">
                    {item.icon}
                    <span className={`text-xs font-bold px-3 py-1 rounded-full ${item.typeBg}`} data-id="element-1715" data-mp="3akr8z53uq3f2">
                      {t(`leadingInComplexity.${item.typeKey}`)}
                    </span>
                  </div>
                  <h3 className="font-bold text-lg text-charcoal mb-2" data-id="element-1716" data-mp="31jt1gcu7fdrq">
                    {t(`leadingInComplexity.${item.titleKey}`)}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed flex-1 mb-4" data-id="element-1717" data-mp="2rmofoe49tkbg">
                    {t(`leadingInComplexity.${item.descKey}`)}
                  </p>
                  <Link to={item.path} data-id="element-1718" data-mp="2mu3olkcr1lbm">
                    <Button variant="outline" size="sm" rightIcon={<ArrowRightIcon size={16} data-id="element-1720" data-mp="2iuuv8glmfpgl" />} data-id="element-1719" data-mp="2iu3ak0tkbc53">
                      {t('leadingInComplexity.learnMore')}
                    </Button>
                  </Link>
                </Card>
              </Animate>)}
          </div>
        </section>

        {/* CTA */}
        <section className="max-w-4xl mx-auto px-4 text-center" data-id="element-1721" data-mp="23ydmzy8qaqy9">
          <Animate data-id="element-1722" data-mp="1ttnndz0sryx7">
            <Card className="p-12 bg-gradient-to-br from-blue-50 to-indigo-50 border-0" data-id="element-1723" data-mp="1tu6zgz3rnt3b">
              <div className="w-16 h-16 mx-auto mb-6 bg-white rounded-full flex items-center justify-center shadow-md" data-id="element-1724" data-mp="1yryw26fcw3du">
                <CalendarIcon size={32} className="text-blue-600" data-id="element-1725" data-mp="23swfsng0l5hg" />
              </div>
              <h2 className="text-3xl font-bold mb-4" data-id="element-1726" data-mp="28qxvqzi58oop">{t('leadingInComplexity.ctaTitle')}</h2>
              <p className="text-gray-600 mb-8 max-w-xl mx-auto" data-id="element-1727" data-mp="1b3p7wxuo73jj">{t('leadingInComplexity.ctaDesc')}</p>
              <Link to="/contact" data-id="element-1728" data-mp="1g17ewip4n8ow">
                <Button variant="primary" rightIcon={<ArrowRightIcon size={18} data-id="element-1730" data-mp="1l1df4n9gq3il" />} data-id="element-1729" data-mp="1g2a6ksu9xf5v">
                  {t('leadingInComplexity.ctaCta')}
                </Button>
              </Link>
            </Card>
          </Animate>
        </section>
      </div>
    </PageTransition>;
}